<script setup lang="ts">
import SectionHeader from '../common/SectionHeader.vue'
import RelatedCompanyCard from './RelatedCompanyCard.vue'
import type { RelatedCompany } from '~~/server/types/company'

const props = defineProps<{
  companies: RelatedCompany[]
  companyName: string
  section: string
}>()
const hasRelatedCompanies = computed(() => {
  return props.companies && props.companies.length > 0
})

const sectionTitle = computed(() => {
  if (!props.section) return ''

  let displayName = ''

  switch (props.section) {
    case 'overview':
      displayName = 'Overview'
      break
    case 'reviews':
      displayName = 'Reviews'
      break
    case 'salaries':
      displayName = 'Salaries'
      break
    case 'jobs':
      displayName = 'Jobs'
      break
    case 'dress-code':
      displayName = 'Dress Code'
      break
    case 'drug-test-policy':
      displayName = 'Drug Test Policy'
      break
    default:
      displayName = props.section.charAt(0).toUpperCase() + props.section.slice(1).replace(/-/g, ' ')
  }

  return `for ${displayName}`
})

const title = computed(() => {
  return `Companies Similar to ${props.companyName} ${sectionTitle.value}`
})
</script>

<template>
  <div v-if="hasRelatedCompanies">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <SectionHeader
        :title="title"
        class="mb-6"
      />
      <div
        class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4"
      >
        <RelatedCompanyCard
          v-for="company in companies"
          :key="company.id"
          :company="company"
          :section="section"
        />
      </div>
    </div>
  </div>
</template>
